import React, { createContext, useContext } from 'react';
const defaultStyles = {
  topLevelBoxStyle: {},
  contentFlexStyle: {},
  inputStyle: {},
  recordingIndicatorStyle: {},
  quickActionsContainer: {}
};
const StyleContext = createContext(defaultStyles);
/**
 * useStandaloneStyles - Hook to access standalone styles
 * @internal
 */
export const useStandaloneStyles = () => useContext(StyleContext);
/**
 * StandaloneStyleProvider - Provider for standalone styles
 * @internal
 */
export const StandaloneStyleProvider = ({
  width = '100%',
  isMobile,
  children,
  isNewPortal
}) => {
  const topLevelBoxStyle = {
    width,
    height: isNewPortal ? 'calc(100% - 200px)' : '100%',
    maxWidth: '1280px',
    style: {
      position: 'absolute',
      top: '115px',
      overflowX: 'hidden'
    }
  };
  const contentFlexStyle = {
    pb: '56px',
    px: 1,
    width: '100%',
    minHeight: '100%',
    overflowY: 'scroll',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  };
  const inputStyle = {
    maxWidth: '1280px',
    width,
    style: {
      position: 'absolute',
      bottom: '0px'
    },
    pt: 2,
    bottom: '0px'
  };
  const recordingIndicatorStyle = {
    height: '200px',
    circleHeight: '140px',
    circleWidth: '140px'
  };
  const quickActionsContainer = {
    mb: '12px'
  };
  return React.createElement(StyleContext.Provider, {
    value: {
      topLevelBoxStyle,
      contentFlexStyle,
      inputStyle,
      recordingIndicatorStyle,
      quickActionsContainer
    }
  }, children);
};